import React, { useState } from "react";

interface OutlinedLabelProps {
	label: string;
	value?: string;
}

const OutlinedLabel: React.FC<OutlinedLabelProps> = ({ label, value = "" }) => {
	const [isFocused, setIsFocused] = useState<boolean>(false);
	const [inputId] = useState<string>(
		`outlined-label-${Math.floor(Math.random() * 100)}`
	);

	const handleFocus = (): void => {
		setIsFocused(true);
	};

	const handleBlur = (): void => {
		setIsFocused(false);
	};

	return (
		<div className="relative w-full mt-4" aria-label="Read-only Field">
			<div className="relative">
				<input
					id={inputId}
					type="text"
					value={value}
					onFocus={handleFocus}
					onBlur={handleBlur}
					readOnly
					className="w-full px-4 py-3 text-primary bg-transparent border rounded-full cursor-default focus:outline-none border-primary-inactive focus:border-primary-active"
					aria-readonly="true"
				/>

				<label
					htmlFor={inputId}
					className={`absolute text-primary transition-all duration-300 pointer-events-none ${
						isFocused || value
							? "text-sm -top-2.5 left-6 pl-1 pr-1 rounded bg-primary-background"
							: "text-base top-3 left-6 bg-transparent"
					}`}
				>
					{label}
				</label>
			</div>
		</div>
	);
};

OutlinedLabel.displayName = "OutlinedLabel";

export default OutlinedLabel;
